import { applyParentTransforms as m } from "./index3.js";
import { getPivot as t } from "./index12.js";
function v(n, i) {
  const p = [];
  for (let r = 0; r < n.length; r++) {
    const o = n[r], s = [
      t([0, 0, 1], o),
      t([1, 0, 1], o),
      t([1, 0, 0], o),
      t([0, 0, 0], o)
    ].map((e) => m(e, o, i));
    p.push(s);
  }
  return p;
}
export {
  v as getFourCorners
};
//# sourceMappingURL=index8.js.map
